import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import _ from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { ParquetDataset } from 'shell-models-lib';
import { FormatDatasetAdapter } from 'app/model/adapters/datasets/format-dataset.adapter';
import { GlobalVariables } from 'app/services/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ParquetDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            schema: '*',
            parameters: '*',
            type: '*',
            linkedServiceName: '*',
            linkedService: '*',
            connectionSettings: __IS_FABRIC_DPE__ ? '*' : undefined,
            connectionProperties: GlobalVariables.disableServerCertificate ? '*' : undefined,
            typeProperties: {
                compressionCodec: '*',
                location: '*'
            }
        }
    }
})
export class ParquetDatasetAdapter extends FormatDatasetAdapter<ParquetDataset, Model.DatasetV2Resource> {
    protected async _toResource(dataset: ParquetDataset): Promise<Model.DatasetV2Resource> {
        const modelDatasetResource = await super._toResource(dataset) as Model.DatasetV2Resource;
        const modelDataset = this.properties(modelDatasetResource) as Model.ParquetDataset;
        modelDataset.type = Metamodel.modelFor(ParquetDataset).name;
        modelDataset.typeProperties = modelDataset.typeProperties || {};
        if (dataset.location) {
            modelDataset.typeProperties.location = this.locationToResource(dataset);
        }
        modelDataset.typeProperties.compressionCodec = ValueAdapter.toResource(dataset, ParquetDataset.COMPRESSION_CODEC);
        modelDataset.schema = this.columnValueToResource(dataset, dataset.columns);
        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            _.merge(modelDatasetResource, parsed);
        }
        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetV2Resource, dataset?: ParquetDataset): Promise<ParquetDataset> {
        if (!dataset) {
            dataset = ParquetDataset.MODEL.create<ParquetDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        if (modelDatasetResource?.properties?.typeProperties?.location) {
            await this.locationToModel(modelDatasetResource, dataset);
        }

        if (modelDatasetResource?.properties?.typeProperties) {
            const typeProps = modelDatasetResource.properties.typeProperties as Model.ParquetDatasetTypeProperties;
            ValueAdapter.toModel(dataset, ParquetDataset.COMPRESSION_CODEC, typeProps.compressionCodec);
        }

        dataset.columns = this.columnResourceToValue(dataset, modelDatasetResource.properties.schema);

        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, ParquetDataset.MODEL));
        return dataset;
    }
}
